<template>
    <li class="contact">
        <div class="contact__content">
            <div>
                <h4>{{ name }}</h4>
                <em class="mt-2">{{ title }}</em>
                <p>
                    <a :href="`tel:${phone}`">{{ phone }}</a>
                </p>
                <p>
                    <a :href="`mailto:${email}`">{{ email }}</a>
                    <info-button v-if="infoText" :text="infoText" />
                </p>
            </div>
        </div>
    </li>
</template>

<script setup lang="ts">
defineProps<{
    title: string;
    name: string;
    phone: string;
    email: string;
    _uid: string;
    infoText?: string;
}>();
</script>

<style lang="scss">
.contact {
    @apply relative max-h-100;
    &__list {
        @apply grid;

        @screen tablet {
            @apply grid-cols-2 gap-1;
        }

        @screen laptop {
            @apply grid-cols-3 gap-1;
        }

        @screen desktop {
            @apply gap-8;
        }
    }

    h4 {
        @apply mb-2 text-current font-medium text-blue-900;
    }

    em {
        @apply font-semibold text-black;
    }

    .fa-angle-right {
        @apply ml-2.5;
    }

    &__content {
        @apply border-t
    border-transparent
    border-opacity-50
    bg-opacity-50
    px-5
    pb-8
    pt-6
    backdrop-blur-lg;
    }
    .n-tooltip {
        @apply w-100;
    }
}
</style>
